// extracted by mini-css-extract-plugin
export default {"container":"NotFoundPage_container__sPT7O","notFoundPage":"NotFoundPage_notFoundPage__6XXzZ"};